import { useEffect, useRef, useState } from "react";
import "../components/lendy/lendyShared.css";

// The classic chat's assistant icon, for an assistant with no picture of its own.
const FALLBACK_IMAGE_URL = `${process.env.PUBLIC_URL || ""}/assistant-icon.svg`;

/**
 * The assistant's picture in a circle, as the classic chat shows it: its own image, the
 * organization's logo, or the assistant icon. `dot` is ready, busy or wait. Until the picture
 * arrives the circle is a quiet placeholder, not an empty white disc.
 */
const AssistantAvatar = ({ imageUrl, size = "profile", dot = "" }) => {
  const [hasFailed, setHasFailed] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const imageRef = useRef(null);
  const src = imageUrl && !hasFailed ? imageUrl : FALLBACK_IMAGE_URL;

  useEffect(() => {
    setHasFailed(false);
  }, [imageUrl]);

  useEffect(() => {
    // A picture already in the browser's cache may be complete before the load handler runs.
    setIsLoaded(Boolean(imageRef.current?.complete && imageRef.current.naturalWidth));
  }, [src]);

  return (
    <span className={`lendy-avatar lendy-avatar--${size}`} aria-hidden="true">
      <span className={`lendy-avatar-clip${isLoaded ? "" : " is-loading"}`}>
        <img
          ref={imageRef}
          className="lendy-avatar-image"
          src={src}
          alt=""
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasFailed(true)}
        />
      </span>
      {dot && <i className={`lendy-avatar-dot lendy-avatar-dot--${dot}`} />}
    </span>
  );
};

export default AssistantAvatar;
